module.exports = __webpack_public_path__ + "static/media/iconfinder_Folder_Win_Download_1215236.7d0c911f.png";